export const NAME = 'config'
export const REDIRECT_LINK = 'redirectLink'
export const IMPERSONATE_USER_ID = 'impersonateUserId'

